// extracted by mini-css-extract-plugin
module.exports = {"app":"AuthShell_app__O0Ol-","page":"AuthShell_page__3Uab4","children":"AuthShell_children__2jG1P","logo":"AuthShell_logo__a2vP9"};